import { Box, Button, Typography } from "@mui/material"
import { ListDetailProps } from "./types"
import { useStyles } from "./styles"
import { Comment } from "../comment"
import { useState } from "react"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { useMutation } from "@tanstack/react-query"
import { scheduleServiceFetch } from "../../../../../../utils/constants/callService"
import { useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { InputComment } from "../inputComment"
import { Types } from "../../../../../../utils/enums"

const ListDetail = ({ title, itemList, notAddComment, existed }: ListDetailProps) => {
    const { id } = useParams()
    const { t } = useTranslation()
    const styles = useStyles()
    const [addComent, setAddComent] = useState(false)
    const [comment, setComment] = useState<null | string>(null)
    const { isPending, mutate } = useMutation({
        mutationFn: scheduleServiceFetch.createComment,
        onSuccess: () => {
            setAddComent(false)
            setComment(null)
            emitEvent(Events.comment, undefined)
            emitEvent(Events.snackbar, {open: true, type: Types.SUCCESS, message: t('general.commentMessage.success')})
        },
        onError: () => {
            emitEvent(Events.snackbar, {open: true, type: Types.ERROR, message: t('general.commentMessage.error')})
        }
    })
    const displayComment = ({ value }: { value: boolean }) => {
        setAddComent(value)
        setComment(null)
    }
    const sendComment = async () => {
        if (!id || !comment) { return }

        mutate({ body: { comment, recurrenceCommentId: null, recurrenceId: id } })
    }
    
    return (
        <CustomPaper sx={styles.container(itemList?.length===0)}>
            <Box sx={styles.header}>
                <Typography variant="subtitle_grey" color='primary.100' fontWeight='bold'>{title}</Typography>

                {!notAddComment && !existed && <Button onClick={() => { displayComment({ value: !addComent }) }} variant="text">{t(`general.${!!addComent ? 'cancelComment' : 'newComment'}`)}</Button>}
            </Box>

            {itemList?.length===0 && !addComent && <Typography sx={styles.noComment} variant="no_comment">{t('schedule.errors.noComments')}</Typography>}

            {
                !notAddComment && (
                    <Box sx={{padding: '0px 8px'}}>
                        <InputComment
                            comment={comment}
                            isPending={isPending}
                            show={!!addComent}
                            sendComment={sendComment}
                            setComment={setComment}
                        />
                    </Box>
                )
            }

            <Box sx={styles.commentContainer}>
                {itemList?.map(comment => (<Comment evidence={comment.evidence} key={comment.id} comment={comment} notAddComment={notAddComment} existed={existed} />))}
            </Box>
        </CustomPaper>
    )
}

export { ListDetail }
